import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import { getBalance } from '@wagmi/core';
import { AGFAddress, AGFstakingaddress } from '../../blockchain/address';
import { useAccount, useConnect, useReadContract, useWriteContract } from 'wagmi';
import stakingAbi from "../../blockchain/staking.json";
import { config } from '../../wagmi';
import { toast } from 'react-toastify';
import agf from "../../blockchain/agf.json";
import { injected } from 'wagmi/connectors'
import util from "../../utils/web3";
import { Web3Provider } from '@ethersproject/providers';
import dayjs from 'dayjs'

interface Tab {
    id: number;
    label: string;
}

const tabs: Tab[] = [
    { id: 1, label: '30' },
    { id: 2, label: '60' },
    { id: 3, label: '90' },
    { id: 4, label: '120' },
    { id: 5, label: '360' },
];

const getRedemptionDays = (multiplier: BigInt) => {
    switch (multiplier) {
        case 1n:
            return 30;
        case 2n:
            return 60;
        case 3n:
            return 90;
        case 4n:
            return 120;
        case 5n:
            return 360;
        default:
            return 0;
    }
};

const StakingDetails: React.FC = () => {
    /*     const result = useReadContract({
            abi: stakingAbi,
            address: AGFstakingaddress,
            functionName: 'userInfo',
            args: [address],
        } as const); */

    const { address } = useAccount();
    // const { isConnected, address } = useAccount();
    const { connectAsync } = useConnect()
    // const { data: walletClient } = useWalletClient();
    // const { writeContract } = useWriteContract();
    const { writeContractAsync } = useWriteContract();
    const [balance, setBalance] = useState<number>(0);
    const [stakeAmount, setStakeAmount] = useState<number | any>('');
    // const [approvedAmt, setapprovedAmt] = useState<number | any>(0);
    const [stakedBal, setStakedBal] = useState<string | any>("-");
    const [stakeDate, setStakeDate] = useState<string | Date>("-");
    const [redemptionDate, setRedemptionDate] = useState<string | Date>('-');
    const [redemptionDay, setRedemptionDays] = useState<number>(0);
    const [estIntAmount, setEstIntAmount] = useState<string | any>("-");
    const [isApproved, setIsApproved] = useState<boolean>(true);
    const [approveAccept, setapproveAccept] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    // const [isStakeDone, setIsStakeDone] = useState<boolean>(false);
    const [stakeLoader, setStakeLoader] = useState<boolean>(false);

    const [totalLockedVal, setTotalLockedVal] = useState<number | null>(null);
    const [totalStakers, setTotalStakers] = useState<number | null>(0);

    const [isWithdraw, setIsWithdraw] = useState<boolean>(false);
    const [canClaimLoader, setCanClaimLoader] = useState<boolean>(false);
    const [canClaim, setCanClaim] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number>(1); // "30" tab id is 1
    // const [stakeDuration, setStakeDuration] = useState<number>(30);

    let result = useReadContract({
        abi: stakingAbi,
        address: AGFstakingaddress,
        functionName: 'userInfo',
        args: [address],
    } as const);

    let totalStakedVal = useReadContract({
        abi: stakingAbi,
        address: AGFstakingaddress,
        functionName: 'totalStakedAmount'
    } as const);

    let totalStakeCount = useReadContract({
        abi: stakingAbi,
        address: AGFstakingaddress,
        functionName: 'totalStakedCount'
    } as const);

    let getApprovedBal = useReadContract({
        abi: agf,
        address: AGFAddress,
        functionName: 'allowance',
        args: [address, AGFstakingaddress]
    } as const)

    let claimApproval = useReadContract({
        abi: stakingAbi,
        address: AGFstakingaddress,
        functionName: 'canClaimReward',
        args: [address]
    } as const)

    useEffect(() => {
        if (address) {
            getApprovedBalance(getApprovedBal);
        }
    }, [getApprovedBal.status, getApprovedBal.isLoading, address]);

    useEffect(() => {
        canClaimApproval(claimApproval);
    }, [claimApproval.status, claimApproval.data]);

    useEffect(() => {
        if (!address) {
            toast.warning('Connect your wallet first')
        }
    }, [address])

    const canClaimApproval = (result: any) => {
        if (result.status === 'success') {
            setCanClaim(result.data);
        }
    }

    const getApprovedBalance = (result: any) => {
        if (result?.status === 'success' && result.data) {
            const stakedAmount = BigInt(result.data.toString());

            const amtt: any = (Number(stakedAmount) / 10 ** 18)
                .toFixed(5)
                .replace(/([0-9]+(\.[1-9]+)?)(\.?0+$)/, '$1')
            // console.log(amtt, 'helloworld')
            if (amtt === 0 || amtt === '0') {
                setapproveAccept(false)
                // setapprovedAmt(amtt)
            } else if (amtt > 0 || amtt > '0') {
                if (stakeLoader === false) {
                    setapproveAccept(true)
                    // setapprovedAmt(amtt)
                }
            } else {
                setapproveAccept(false)
            }
        }
        if (result?.error) {
            // console.log(address, 'address')
            if (address) {
                // toast.error(result.error.toString());
            }
        }
    }

    useEffect(() => {
        if (!address) return;
        fetchBalance();
    }, [address, AGFAddress, result.status]);

    const fetchBalance = async () => {
        try {
            const userBalance = await getBalance(config as any, {
                address: address as `0x${string}`, // Ensure address is properly typed
                token: AGFAddress,
            });
            // console.log(userBalance, 'userBalanaceisherer')
            setBalance(Number(userBalance?.formatted)); // Or whatever format you prefer
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (address) {
            executeLogic(result);
        }
    }, [result.status, result.data, address]);

    let executeLogic = (result: any) => {
        if (result.status === "success" && result?.data.length > 0) {
            // console.log(result, 'resultdataishere')
            // Assert that result.data is an array of BigInts
            const data = result.data as [BigInt, BigInt, BigInt, BigInt];


            const stakedAmount = data[0] === 0n ? '0' : Number(data[0].toString()) / 10 ** 18;
            setStakedBal(stakedAmount);


            const stakeDate = data[1] === 0n ? '-' : new Date(Number(data[1].toString()) * 1000); // Convert seconds to milliseconds
            setStakeDate(stakeDate);

            const redemptionDays = getRedemptionDays(data[3]);

            setRedemptionDays(redemptionDays)

            if (redemptionDays > 0 && stakeDate !== '-') {
                const redemptionDate = new Date(stakeDate);
                redemptionDate.setDate(stakeDate.getDate() + redemptionDays);

                const formattedRedemptionDate = formatDateToDDMMYYYY(redemptionDate);
                setRedemptionDate(formattedRedemptionDate);
            } else {
                setRedemptionDate('-'); // If no valid days, set '-'
            }

            const estimatedIntAmount = data[2] === 0n ? '-' : Number(data[2].toString()) / 10 ** 18;
            setEstIntAmount(estimatedIntAmount);
        }
        if (result?.error) {
            if (address) {
                // toast.error(result.error.toString());
            }
        }
    }

    let getTotalValLocked = (totalStakedVal: any) => {
        if (totalStakedVal?.status === 'success' && totalStakedVal.data) {
            const stakedAmount = BigInt(totalStakedVal.data.toString());
            const normalizedStakedAmount = Number(stakedAmount) / 10 ** 18;
            setTotalLockedVal(normalizedStakedAmount);

        }
        if (totalStakedVal?.error) {
            if (address) {
                // toast.error(totalStakedVal.error.toString());
            }
        }
    }

    useEffect(() => {
        getTotalValLocked(totalStakedVal);
    }, [totalStakedVal?.status, totalStakedVal.data]);


    let getTotalStakeCount = (totalStakedCount: any) => {
        if (totalStakedCount?.status === 'success' && totalStakedCount.data) {
            const stakedAmount = BigInt(totalStakedCount.data.toString());
            const normalizedStakedAmount = Number(stakedAmount);
            setTotalStakers(normalizedStakedAmount);
        }
        if (totalStakedCount?.error) {
            if (address) {
                // toast.error(totalStakedCount?.error.toString());
            }
            // toast.error(totalStakedCount.toString());
        }
    }

    useEffect(() => {
        getTotalStakeCount(totalStakeCount);
    }, [totalStakeCount?.status, totalStakeCount.data]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // const { value } = e.target;
        parseInt(e.target.value) > 0 &&
            e.target.value.match(/^(\d*\.{0,1}\d{0,5}$)/)
            ? setIsApproved(true)
            : setIsApproved(false)
        // const num = parseInt(e.target.value)
        setStakeAmount(e.target.value)
    };

    // Handler function for approval
    const handleApproval = async () => {
        if (!address) {
            await connectAsync({ chainId: 4002, connector: injected() as any });
            return
        }
        if (stakeAmount >= 100) {
            try {

                setIsLoading(true); // Start loading state

                if (stakedBal > 0) {
                    toast.warning('You already have approved balance, Withdraw first!');
                    return;
                }

                if (!address) {
                    await connectAsync({ chainId: 4002, connector: injected() as any });
                    setIsApproved(true);
                    return
                }

                // Step 1: Calculate the approval amount based on inputVal
                var approveamt = stakeAmount * 10 ** 18;

                // Step 2: Handle large numbers without exponents
                var amount = util.noExponents(approveamt);

                // Step 3: Call the contract's approve function and get transaction hash
                let txHash: any = await writeContractAsync({
                    chainId: 4002,
                    address: AGFAddress, // change to recipient address
                    functionName: 'approve',
                    abi: agf,
                    args: [
                        AGFstakingaddress,
                        amount, // Pass the formatted stake amount here
                    ],
                });

                // Step 4: Wait for the transaction to be mined using the provider
                const provider = new Web3Provider(window.ethereum);
                const txReceipt = await provider.waitForTransaction(txHash);

                // Step 5: Handle success case if the transaction is confirmed
                if (txReceipt && txReceipt.status === 1) {
                    toast.success('Approval successful!');
                    getApprovedBal.refetch();
                    setIsLoading(false);
                    setIsApproved(false);
                } else {
                    toast.error("Approval failed. Please try again.");
                    setIsLoading(false);
                }

            } catch (error) {
                toast.error('Approval failed. Please try again.');
                console.error(error);
            } finally {
                setIsLoading(false); // Stop loading state
            }
        }
        else {
            toast.warning('Minimum Stake Amount : 100');
        }
    };

    const stakeHandler = async () => {
        if (stakedBal > 0) {
            toast.warning('Please withdraw first to stake again!')
        }
        else {
            try {

                if (!address) {
                    await connectAsync({ chainId: 4002, connector: injected() as any });
                    return
                }
                setStakeLoader(true);

                // console.log(stakeAmount, 'stakeamountttt')

                // Step 1: Calculate the approval amount based on inputVal
                var approveamt = stakeAmount * 10 ** 18;

                // Step 2: Handle large numbers without exponents
                var amount = util.noExponents(approveamt);

                // Step 3: Call the contract's approve function and get transaction hash
                let txHash: any = await writeContractAsync({
                    chainId: 4002,
                    address: AGFstakingaddress, // recipient address
                    functionName: 'deposit',
                    abi: stakingAbi,
                    args: [
                        amount, // Formatted stake amount
                        activeIndex //staking Duration e.g 1, 2, 3
                    ],
                });

                // Step 4: Wait for the transaction to be mined using the provider
                const provider = new Web3Provider(window.ethereum);
                const txReceipt = await provider.waitForTransaction(txHash);

                // Step 5: Handle success case if the transaction is confirmed
                if (txReceipt && txReceipt.status === 1) {
                    // usersCount();
                    toast.success('Staking successful!');
                    setStakeAmount(0);
                    // setIsStakeDone(true);
                    setStakeLoader(false);
                    result.refetch();
                    totalStakedVal.refetch();
                    totalStakeCount.refetch();
                    fetchBalance();
                    // console.log(result, 'result')
                } else {
                    toast.error("Staking failed. Please try again.");
                    setStakeLoader(false);
                }
            } catch (error) {
                toast.error('Staking failed. Please try again.');
                setStakeLoader(false);
                console.error(error);
            } finally {
                setStakeLoader(false);
            }
        }
    };

    // Handler function for withdrawal
    const withdrawHandler = async () => {
        if (stakedBal <= 0) {
            toast.error('You have no staked balance to withdraw.');
            return;
        }
        try {

            if (!address) {
                await connectAsync({ chainId: 4002, connector: injected() as any });
                return
            }

            setIsWithdraw(true);

            // Step 1: Calculate the approval amount based on inputVal
            // var approveamt = stakeAmount * 10 ** 18;

            // Step 2: Handle large numbers without exponents
            // var amount = util.noExponents(approveamt);

            // Step 3: Call the contract's approve function and get transaction hash
            let txHash: any = await writeContractAsync({
                chainId: 4002,
                address: AGFstakingaddress, // change to recipient address
                functionName: 'withdraw',
                abi: stakingAbi
            });

            // console.log('Transaction hash:', txHash);

            // Step 4: Wait for the transaction to be mined using the provider
            const provider = new Web3Provider(window.ethereum);
            const txReceipt = await provider.waitForTransaction(txHash);

            // Step 5: Handle success case if the transaction is confirmed
            if (txReceipt && txReceipt.status === 1) {
                toast.success('Withdraw successful!');
                // setIsStakeDone(false);
                setIsApproved(false);
                setStakedBal(0);
                result.refetch();
                totalStakedVal.refetch();
                totalStakeCount.refetch();
                fetchBalance();
                setIsWithdraw(false);
            } else {
                toast.error("Withdraw failed. Please try again.");
                setIsWithdraw(false);
            }
        } catch (error) {
            toast.error('Withdraw failed. Please try again.');
            console.error(error);
            setIsWithdraw(false);
        } finally {
            setIsLoading(false); // Stop loading state
            setIsWithdraw(false);
        }
    };

    //Handler function for claim reward
    const claimHandler = async () => {
        try {

            if (!address) {
                await connectAsync({ chainId: 4002, connector: injected() as any });
                return
            }

            setCanClaimLoader(true);

            // Step 1: Calculate the approval amount based on inputVal
            // var approveamt = stakeAmount * 10 ** 18;

            // Step 2: Handle large numbers without exponents
            // var amount = util.noExponents(approveamt);

            // Step 3: Call the contract's approve function and get transaction hash
            let txHash: any = await writeContractAsync({
                chainId: 4002,
                address: AGFstakingaddress, // change to recipient address
                functionName: 'claim',
                abi: stakingAbi
            });

            // Step 4: Wait for the transaction to be mined using the provider
            const provider = new Web3Provider(window.ethereum);
            const txReceipt = await provider.waitForTransaction(txHash);

            // Step 5: Handle success case if the transaction is confirmed
            if (txReceipt && txReceipt.status === 1) {
                // console.log(txReceipt, 'txReceipt')
                toast.success('Rewards claimed successfully!!');
                setCanClaimLoader(false);
            } else {
                toast.error("There is some problem. Please try again!");
                setCanClaimLoader(false)
            }
        } catch (error) {
            toast.error('Please try again after sometime');
            console.error(error);
            setCanClaimLoader(false);
        } finally {
            setIsLoading(false); // Stop loading state
            setCanClaimLoader(false);
        }
    };

    const handleClick = (item: any) => {
        setActiveIndex(item.id);
        // setStakeDuration(item.label);
    };

    // Define APY values corresponding to tab ids
    const apyValues: { [key: number]: string } = {
        1: '5%',
        2: '7%',
        3: '9%',
        4: '12%',
        5: '18%'
    };

    // Get the lock period from the selected tab's label
    const lockPeriod = tabs.find(tab => tab.id === activeIndex)?.label || '1'
    const apy = apyValues[activeIndex] || '5%';

    const formatDate = (date: Date | string) => {
        if (!date) return '';
        if (date === '-') return '-';
        return dayjs(date).format('DD/MM/YYYY');
    };

    // Function to format date using Day.js
    const formatDateToDDMMYYYY = (date: Date): string => {
        return dayjs(date).format('DD/MM/YYYY'); // Format the date using Day.js
    };

    return (
        <Layout title='Agrifi Staking Details'>
            <svg viewBox="0 0 1208 1024" aria-hidden="true" className="hidden lg:block opacity-20 absolute -bottom-12 left-1/2 h-[47rem] -translate-x-1/2 translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] lg:-top-12 lg:bottom-auto lg:translate-y-0">
                <ellipse cx="604" cy="512" fill="url(#d25c25d4-6d43-4bf9-b9ac-1842a30a4867)" rx="604" ry="512" />
                <defs>
                    <radialGradient id="d25c25d4-6d43-4bf9-b9ac-1842a30a4867">
                        <stop stopColor="#7775D6" />
                        <stop offset="1" stopColor="#E935C1" />
                    </radialGradient>
                </defs>
            </svg>
            {/* <svg className="opacity-40 absolute inset-0 size-full stroke-gray-700 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]" aria-hidden="true">
            <defs>
              <pattern id="54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2" width="200" height="200" x="100%" y="-1" patternUnits="userSpaceOnUse">
                <path d="M130 200V.5M.5 .5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="100%" y="-1" className="overflow-visible fill-gray-800/20">
              <path d="M-470.5 0h201v201h-201Z" stroke-width="0" />
            </svg>
            <rect width="100%" height="100%" stroke-width="0" fill="url(#54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2)" />
          </svg> */}
            <main className="pb-8 relative">
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="sr-only">Page title</h1>
                    {/* Main 3 column grid */}
                    <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8 mt-2">
                        {/* Left column */}
                        <div className="grid grid-cols-1 gap-4 lg:col-span-2">
                            <section aria-labelledby="section-1-title">
                                <h2 id="section-1-title" className="sr-only te">
                                    Section title
                                </h2>
                                <div className="overflow-hidden rounded-lg bg-gray-700/10">
                                    <div className="p-6">
                                        {/* <h1 className="text-2xl font-bold sm:text-3xl">Participate Staking</h1> */}
                                        {/* <span className="mt-2 text-sm text-gray-300">256.50 USDT</span> */}
                                        <ul
                                            className="md:w-fit flex-wrap justify-center text-center text-gray-300"
                                            id="myTab"
                                            data-tabs-toggle="#StarterContent"
                                            role="tablist"
                                        >
                                            {tabs.map((tab) => (
                                                <li key={tab.id} role="presentation" className="md:inline-block inline-block md:w-fit cursor-pointer">
                                                    <div
                                                        className={`px-3 py-2 text-sm font-medium w-full transition-all duration-500 ease-in-out ${activeIndex === tab.id ? 'bg-green-600/30 text-indigo-100 ring-1 ring-inset ring-green-400/30' : ''}`}
                                                        onClick={() => handleClick(tab)}
                                                    >
                                                        {tab.label}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className=''>
                                            <div className="flex p-6 w-full justify-between items-center bg-gray-400/10 rounded-lg shadow mt-6">
                                                {/* <h2 className="text-sm font-semibold text-indigo-600">Starter <span className="sr-only">plan</span></h2>
                                                        <p className="mt-2 text-pretty text-sm/6 text-gray-600">Everything you need to get started.</p> */}
                                                <div className="text-sm text-gray-300">
                                                    <li className="group flex items-start gap-4 text-sm/6 font-medium text-gray-400 data-[disabled]:text-gray-400">
                                                        <span className="inline-flex h-6 items-center">
                                                            <svg className="size-4 fill-gray-400 group-data-[disabled]:fill-gray-300" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
                                                                <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                                                            </svg>
                                                        </span>
                                                        Staking
                                                    </li>

                                                    <li className="group flex items-start gap-4 text-sm/6 font-medium text-gray-400 data-[disabled]:text-gray-400">
                                                        <span className="inline-flex h-6 items-center">
                                                            <svg className="size-4 fill-gray-400 group-data-[disabled]:fill-gray-300" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
                                                                <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                                                            </svg>
                                                        </span>
                                                        Lock period: {lockPeriod} days
                                                    </li>

                                                    <li className="group flex items-start gap-4 text-sm/6 font-medium text-gray-400 data-[disabled]:text-gray-400">
                                                        <span className="inline-flex h-6 items-center">
                                                            <svg className="size-4 fill-gray-400 group-data-[disabled]:fill-gray-300" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
                                                                <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                                                            </svg>
                                                        </span>
                                                        Early unstake fee:  2%
                                                    </li>

                                                </div>

                                                <div className='text-gray-300'>
                                                    <span className='text-4xl font-semibold p-2 text-gray-300'>{apy}</span>
                                                    <span>APY*</span>
                                                </div>
                                            </div>

                                            <div className="w-full justify-between items-center shadow mt-4 text-gray-300">
                                                <h4 className="text-base/7 font-semibold text-green-400/60">Staking for {lockPeriod} days</h4>
                                                <div className="items-center justify-center ">
                                                    <div className="grid grid-cols-1 w-full mb-2 mt-1.5">
                                                        <label className='flex text-sm/6 font-semibold text-white'>Balance : {balance ? `${balance?.toFixed(4)} AGF` : '0'}</label>
                                                        <div className="flex space-x-3 mt-2">
                                                            <input
                                                                type="text"
                                                                value={stakeAmount}
                                                                min={0}
                                                                className="px-4 py-2 sm:grid-cols-3 w-full border bg-transparent rounded-l-md outline outline-1 -outline-offset-1 outline-white/10 focus:border-violet-600 focus:ring-0 start"
                                                                placeholder="00.00"
                                                                onChange={handleChange}
                                                                aria-label="Stake amount"
                                                            />
                                                            {
                                                                isApproved === true && stakeAmount > 0 && stakeAmount !== '' ? (
                                                                    <button
                                                                        onClick={handleApproval}
                                                                        className='px-6 py-2 mr-2 flex items-center justify-center rounded-md font-medium transition-all duration-500 ease-in-out bg-violet-600'
                                                                    >
                                                                        {isLoading ? 'approving...' : 'Approve'}
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        disabled
                                                                        style={{ backgroundColor: 'gray' }}
                                                                        className='rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20'
                                                                    >
                                                                        Approve
                                                                    </button>
                                                                )}&nbsp;
                                                            {approveAccept && stakeAmount > 0 ? (
                                                                <button
                                                                    className="px-6 py-2 mr-2 flex rounded-md font-medium transition-all duration-500 ease-in-out bg-violet-600"
                                                                    onClick={stakeHandler}
                                                                >
                                                                    {stakeLoader ? 'staking...' : 'Stake'}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="px-3 py-2 rounded-md font-medium transition-all duration-500 ease-in-out"
                                                                    disabled
                                                                >
                                                                    Stake
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-1 w-full mb-4 mt-4">
                                                        <label className='flex text-sm/6 font-semibold text-white'>Total Staked Amount</label>
                                                        <div className="flex space-x-3 mt-1.5">
                                                            <div className="px-4 py-2 text-sm border border-gray-400 w-full bg-transparent rounded-l-md start">
                                                                <span className="text-white">{stakedBal}</span>
                                                            </div>
                                                            <button
                                                                onClick={withdrawHandler}
                                                                disabled={isWithdraw}
                                                                className="rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-white/20"
                                                            >
                                                                {isWithdraw ? 'withdrawing...' : 'Withdraw'}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="grid grid-cols-1 w-full mt-4">
                                                        <label className='flex text-sm/6 font-semibold text-white'>Total Reward Amount</label>
                                                        <div className="flex space-x-3 mt-1.5">
                                                            <div className="px-4 py-2 text-sm border border-gray-400 w-full bg-transparent rounded-l-md outline outline-1 -outline-offset-1 outline-white/10 focus:border-violet-600 focus:ring-0 start">
                                                                <span className="text-white">{estIntAmount ? `${estIntAmount.toString().slice(0, 6)}` : '-'}</span>
                                                            </div>
                                                            <button
                                                                onClick={claimHandler}
                                                                disabled={!canClaim}
                                                                className="px-3 py-2 text-sm font-semibold ml-2 rounded-md transition-all duration-500 ease-in-out bg-green-600/35"
                                                            >
                                                                {canClaimLoader ? 'claiming...' : 'Claim'}
                                                            </button>
                                                        </div>

                                                        <div className='flex justify-end' style={{ fontSize: '12px' }}>{
                                                            !canClaim ? <p className="text-red-500 text-sm mt-2">Claim your rewards after lock period*</p> : <p className="text-green-500 text-sm mt-2">Claim rewards*</p>
                                                        }</div>
                                                    </div>
                                                </div>
                                                {
                                                    stakedBal > 0 && <div className="mt-6">
                                                        <p className='text-sm'>You currently have an active stake of {stakedBal} AGF.</p>
                                                        <p className='text-sm'>If you wish to stake more, you need to unstake your current staked amount and then restake with the new amount.</p>
                                                        {/* <p className="text-sm">Once staked, you need to register for every IDO, so we can calculate the guaranteed allocation. Once registered, we lock your tokens, but you still can participate in other IDOs.</p> */}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* Right column */}
                        {/* <div className="grid grid-cols-1 gap-4">
                            <section aria-labelledby="section-2-title">
                                <h2 id="section-2-title" className="sr-only">
                                    Section title
                                </h2>
                                <div className="overflow-hidden rounded-lg bg-white shadow">
                                    <div className="p-6">hello</div>
                                </div>
                            </section>
                        </div> */}
                        <div className="grid grid-cols-1 gap-4">
                            {/* <!-- Announcements --> */}
                            <section aria-labelledby="announcements-title">
                                <div className="overflow-hidden rounded-lg bg-gray-600/10">
                                    <div className="p-6">
                                        {/* <h2 className="text-base font-medium text-gray-100" id="announcements-title">Important</h2> */}
                                        <div className="mx-auto max-w-xs px-8">
                                            {/* <p className="text-base font-semibold text-gray-600">Pay once, own it forever</p> */}
                                            <p className="mt-4 flex items-baseline justify-center gap-x-2">
                                                <span className="text-5xl font-semibold tracking-tight text-green-500 animate-pulse">{totalLockedVal ? totalLockedVal : 0}</span>
                                                <span className="text-sm/6 font-semibold tracking-wide text-gray-400">AGF</span>
                                            </p>
                                            {/* <a href="#" className="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Get access</a> */}
                                            <p className="mt-4 text-gray-300 text-center">Total users value locked</p>
                                        </div>
                                        {/* <div className="mt-6 flow-root">
                                            <ul role="list" className="-my-5 divide-y divide-gray-200">
                                                <li className="py-5">
                                                    <div className="relative focus-within:ring-2 focus-within:ring-cyan-500">
                                                        <h3 className="text-sm font-semibold text-gray-300">
                                                            <div className="hover:underline focus:outline-none">
                                                                <span className="absolute inset-0" aria-hidden="true"></span>
                                                                Office closed on July 2nd
                                                            </div>
                                                        </h3>
                                                        <p className="mt-1 line-clamp-2 text-sm text-gray-600">Cum qui rem deleniti. Suscipit in dolor veritatis sequi aut. Vero ut earum quis deleniti. Ut a sunt eum cum ut repudiandae possimus. Nihil ex tempora neque cum consectetur dolores.</p>
                                                    </div>
                                                </li>
                                                <li className="py-5">
                                                    <div className="relative focus-within:ring-2 focus-within:ring-cyan-500">
                                                        <h3 className="text-sm font-semibold text-gray-300">
                                                            <div className="hover:underline focus:outline-none">
                                                                <span className="absolute inset-0" aria-hidden="true"></span>
                                                                New password policy
                                                            </div>
                                                        </h3>
                                                        <p className="mt-1 line-clamp-2 text-sm text-gray-600">Alias inventore ut autem optio voluptas et repellendus. Facere totam quaerat quam quo laudantium cumque eaque excepturi vel. Accusamus maxime ipsam reprehenderit rerum id repellendus rerum. Culpa cum vel natus. Est sit autem mollitia.</p>
                                                    </div>
                                                </li>
                                                <li className="py-5">
                                                    <div className="relative focus-within:ring-2 focus-within:ring-cyan-500">
                                                        <h3 className="text-sm font-semibold text-gray-300">
                                                            <a href="#" className="hover:underline focus:outline-none">
                                                                <span className="absolute inset-0" aria-hidden="true"></span>
                                                                Office closed on July 2nd
                                                            </a>
                                                        </h3>
                                                        <p className="mt-1 line-clamp-2 text-sm text-gray-600">Tenetur libero voluptatem rerum occaecati qui est molestiae exercitationem. Voluptate quisquam iure assumenda consequatur ex et recusandae. Alias consectetur voluptatibus. Accusamus a ab dicta et. Consequatur quis dignissimos voluptatem nisi.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="mt-6">
                                            <a href="#" className="flex w-full items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">View all</a>
                                        </div> */}
                                    </div>
                                </div>
                            </section>


                            <section aria-labelledby="recent-hires-title">
                                <div className="overflow-hidden rounded-lg bg-gray-600/10 shadow">
                                    <div className="p-6">
                                        <h2 className="text-base font-medium text-gray-100" id="recent-hires-title">Recent Transactions</h2>
                                        <div className="mt-0 flow-root">
                                            <dl className="mt-2 ">
                                                <div className="flex justify-between py-2 text-sm">
                                                    <dt className="text-gray-300 font-medium">Stake date</dt>
                                                    <dd className="whitespace-nowrap text-gray-300">{formatDate(stakeDate)}</dd>
                                                </div>
                                                <div className="flex justify-between py-2 text-sm">
                                                    <dt className="text-gray-300 font-medium">Estimated Interest Amount</dt>
                                                    <dd className="whitespace-nowrap text-gray-300">{estIntAmount ? `${estIntAmount.toString().slice(0, 6)}` : '-'}</dd>
                                                </div>
                                                <div className="flex justify-between py-2 text-sm">
                                                    <dt className="text-gray-300 font-medium">Redemption Date</dt>
                                                    <dd className="whitespace-nowrap text-gray-300">{redemptionDate.toString()}</dd>
                                                </div>
                                                <div className="flex justify-between py-2 text-sm ">
                                                    <dt className="text-gray-300 font-medium">Locking Period (in days)</dt>
                                                    <dd className="whitespace-nowrap text-gray-300">{redemptionDay.toString()}</dd>
                                                </div>
                                            </dl>
                                        </div>

                                    </div>
                                </div>
                            </section>

                            <section aria-labelledby="announcements-title">
                                <div className="overflow-hidden rounded-lg bg-gray-600/10">
                                    <div className="p-6">
                                        {/* <h2 className="text-base font-medium text-gray-100" id="announcements-title">Important</h2> */}
                                        <div className="mx-auto max-w-xs px-8">
                                            {/* <p className="text-base font-semibold text-gray-600">Pay once, own it forever</p> */}
                                            <p className=" flex items-baseline justify-center gap-x-2">
                                                <span className="text-5xl font-semibold tracking-tight text-green-500">{totalStakers}</span>
                                            </p>
                                            {/* <a href="#" className="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Get access</a> */}
                                            <p className="mt-4 text-gray-300 text-center">Number of stakers</p>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default StakingDetails